const companyProfileActionConstants = {
  GET_COMPANY_PROFILE: 'GET_COMPANY_PROFILE',
  GET_COMPANY_PROFILE_SUCCESS: 'GET_COMPANY_PROFILE_SUCCESS',
  GET_COMPANY_PROFILE_ERROR: 'GET_COMPANY_PROFILE_ERROR',
};

export default companyProfileActionConstants;
